import AddIcon from '@mui/icons-material/Add';
import { Dispatch, ReactElement, SetStateAction } from 'react';

import { ICustomDictionaryItem, ICustomDictionaryType } from '~/services/api/dictionaries/types';
import Button from '~/ui/components/common/Button';
import ConfirmModal from '~/ui/components/common/ConfirmModal';
import DictionariesList from './components/DictionariesList/DictionariesList';
import ModalForm from './components/ModalForm';
import Table from './components/Table';

import DictionaryActionTYPE from './enums/dictionaryActionTypes';
import { getAddLabel } from './helpers/dictionaryType';

import styles from './Dictionaries.module.scss';

interface IDictionariesProps {
  dictionaryType?: ICustomDictionaryType;
  defaultDictionaryType?: ICustomDictionaryType;
  dictionaryTypes: ICustomDictionaryType[];
  hasCustomFields: boolean;
  actionType: DictionaryActionTYPE | null;
  hasAlternativeValues: boolean;
  dictionaryItem: ICustomDictionaryItem | null;
  actionModalText: string;
  modalTitle: string;
  confirmText?: string;
  description?: string;
  tableClassName?: string;
  stickyHeader?: boolean;
  clinicId?: number;
  hideHeader?: boolean;
  setDictionaryType: (item: ICustomDictionaryType) => void;
  setDictionaryItem: Dispatch<SetStateAction<ICustomDictionaryItem | null>>;
  onAddDictionaryItem: () => void;
  onEditDictionaryItem: (item: ICustomDictionaryItem) => void;
  handleDictionaryItemUpdateOrAdd: (item: ICustomDictionaryItem) => void;
  onClose: () => void;
  onConfirmation: () => void;
}

const Dictionaries = ({
  dictionaryType,
  defaultDictionaryType,
  dictionaryTypes,
  hasCustomFields,
  actionType,
  dictionaryItem,
  hasAlternativeValues,
  actionModalText,
  modalTitle,
  confirmText,
  description,
  tableClassName,
  stickyHeader,
  clinicId,
  hideHeader,
  onAddDictionaryItem,
  setDictionaryItem,
  setDictionaryType,
  onEditDictionaryItem,
  handleDictionaryItemUpdateOrAdd,
  onClose,
  onConfirmation,
}: IDictionariesProps): ReactElement => (
  <div>
    {!hideHeader && (
      <div className={styles.header}>
        <h2>Dictionaries</h2>
        <Button
          color="primary"
          variant="contained"
          startIcon={<AddIcon />}
          onClick={() => onAddDictionaryItem()}
        >
          {getAddLabel(dictionaryType)}
        </Button>
      </div>
    )}
    <div className={styles.content}>
      {!defaultDictionaryType && (
        <DictionariesList
          dictionaryTypes={dictionaryTypes}
          selectedDictionaryType={dictionaryType.type}
          setDictionaryType={setDictionaryType}
        />
      )}

      {dictionaryType.type && (
        <div className={styles.tableContainer}>
          <Table
            dictionaryType={dictionaryType}
            hasCustomFields={hasCustomFields}
            setDictionaryItem={setDictionaryItem}
            onEditDictionaryItem={onEditDictionaryItem}
            clinicId={clinicId}
            tableClassName={tableClassName}
            stickyHeader={stickyHeader}
          />
        </div>
      )}

      {actionType && dictionaryItem && (
        <ModalForm
          hasCustomFields={hasCustomFields}
          hasAlternativeValues={hasAlternativeValues}
          dictionaryType={dictionaryType}
          dictionaryItem={dictionaryItem}
          handleDictionaryItemUpdateOrAdd={handleDictionaryItemUpdateOrAdd}
          onClose={onClose}
          actionModalText={actionModalText}
          modalTitle={modalTitle}
        />
      )}

      {!actionType && dictionaryItem && (
        <ConfirmModal
          confirmText={confirmText}
          description={description}
          onConfirm={() => {
            onConfirmation();
          }}
          onClose={() => onClose()}
        />
      )}
    </div>
  </div>
);

export default Dictionaries;
